import React, { Component } from "react";
import { connect } from "react-redux";
import { TextField } from "material-ui";
import { CustomDrawer } from "../../Shared";
//import InfiniteScroll from "react-infinite-scroll-component";
import debounce from "lodash/debounce";
import { FullWidthButton, Alert } from "../../Shared";
import LocationListItem from "./LocationListItem";
import { onLocationSelect } from "../stepHelpers";
import * as STEP_KEYS from "../../../consts/stepKeys";
import { locationSelector } from "../../../selectors";
import {
  updateAppointmentDetail,
  toggleControl,
  goToStep,
  goBackToStep,
  completeStep,
  updateLocationPosition
} from "../../../actions";
import { deepGet } from "../../../../../utils";

class LocationDrawer extends Component {
  constructor(props) {
    super(props);
    this.state = { page: 1, pageSize: 3, filterBy: "" };
    this.debouncedFilterByChange = debounce(this.handleFilterByChange, 300);
  }

  handleFilterByChange = value => {
    this.setState({ filterBy: value });
  };

  handleInputChange = e => {
    const { value } = e.target;
    this.debouncedFilterByChange(value);
  };

  handlePositionUpdate = (locationId, position) => {
    this.props.updateLocationPosition(locationId, position);
  };

  handleLocationSelect = location => {
    this.props.toggleControl(STEP_KEYS.LOCATION, false);
    if (
      deepGet(location, ["locationId"], "ANY") === this.props.value &&
      !this.props.current
    ) {
      return;
    }
    onLocationSelect(this.props, location);
  };

  handleLoadMore = () => {
    this.setState({ page: this.state.page + 1 });
  };

  handleDawerRequestChange = open => {
    this.props.toggleControl(STEP_KEYS.LOCATION, open);
  };

  filterLocations = () => {
    const filterBy = this.state.filterBy.toLowerCase();
    if (!filterBy) return this.props.options;

    return this.props.options.filter(location => {
      const { name, streetAddress, postcode, suburb, country } = location;
      return (
        name.toLowerCase().includes(filterBy) ||
        streetAddress.toLowerCase().includes(filterBy) ||
        postcode.toLowerCase().includes(filterBy) ||
        suburb.toLowerCase().includes(filterBy) ||
        country.toLowerCase().includes(filterBy)
      );
    });
  };

  renderLocations = () => {
    if (!this.props.isOpen) return null;
    const filteredLocations = this.filterLocations();
    if (filteredLocations.length === 0) {
      return <Alert message="No location available" />;
    }
    //const { page, pageSize } = this.state;
    const self = this;
    return (
      //.slice(0, page * pageSize)
      filteredLocations.map(location => {
        return (
          <LocationListItem
            key={location.locationId}
            location={location}
            selected={this.props.value === location.locationId}
            onClick={self.handleLocationSelect}
            onPositionLoad={this.handlePositionUpdate}
          />
        );
      })
    );
  };

  renderAnyLocationButton = () => {
    if (!this.props.isTimeZoneUnique || this.props.options.length <= 1) {
      return null;
    }

    return (
      <FullWidthButton
        label="Any available location"
        onClick={() => this.handleLocationSelect(null)}
      />
    );
  };

  render() {
    return (
      <CustomDrawer
        onRequestChange={this.handleDawerRequestChange}
        open={this.props.isOpen}
      >
        <span className="drawer-title">Select preferred location:</span>

        {this.renderAnyLocationButton()}
        <TextField
          id="location_search"
          style={{ width: "100%" }}
          inputStyle={{ padding: "0 0.5em" }}
          underlineFocusStyle={{ borderColor: "#ed135d" }}
          onChange={this.handleInputChange}
        />
        <div className="drawer-list">{this.renderLocations()}</div>
      </CustomDrawer>
    );
  }
}

export default connect(
  locationSelector,
  {
    updateAppointmentDetail,
    toggleControl,
    goToStep,
    goBackToStep,
    completeStep,
    updateLocationPosition
  }
)(LocationDrawer);



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/components/Steps/DrawerContent/LocationDrawer.js